<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Edit Disciplinary Violation :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/employees/disciplinary-actions">
                            <i class="fa fa-gavel"></i> Disciplinary Actions
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/employees/disciplinary-actions#violations">
                            Violation Types
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <i class="fa fa-trash"></i> Delete: {{ violation.violation_name }}
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-9 col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="alert alert-warning" v-if="in_use">
                                <strong>Note:</strong> You cannot delete this violation type because it is currently used by exisiting historical disciplinary actions, so it will be marked inactive and hidden from the Violation list when creating new disciplinary actions.
                            </div>
                            <div class="alert alert-danger" v-else>
                                <strong>Warning:</strong> You are about to delete this violation type. This is permanent and cannot be undone.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <button type="button" class="btn btn-warning" v-on:click="deleteViolation(this)" :disabled="deleting" v-if="in_use">
                Mark Inactive
            </button>
            <button type="button" class="btn btn-danger" v-on:click="deleteViolation(this)" :disabled="deleting" v-else>
                Delete Violation Type
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                deleting: false,
                disc_violation_id: this.$route.params.id,
                violation: {},
                in_use: false,
                errors: {},
            }
        },

        methods: {

            getViolation() {
                //Get the data
                this.$http
                    .get('admin/disciplinary-violations/delete/' + this.disc_violation_id)
                    .then(response => {
                        //Set all the data
                        this.violation = response.data.violation;
                        this.in_use = response.data.in_use

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            deleteViolation() {
                //Show loading
                this.deleting = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('admin/disciplinary-violations/delete/' + this.disc_violation_id)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Disciplinary Violation Deleted');

                    //Return to main list?
                    this.$router.push('/employees/disciplinary-actions#violations');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //Show loading
                    this.deleting = false;
                });
            }
        },

        mounted() {
            //Get the Violation
            this.getViolation();
        }
    }
</script>
